import { ExternalLink } from "lucide-react";

const Score = ({ s, rank }) => (
  <span data-testid="photo-match-score" className={`absolute z-10 top-1 left-1 text-[10px] font-mono font-bold px-1.5 py-0.5 rounded ${rank < 3 ? "bg-emerald-600 text-white" : "bg-black/60 text-white"}`}>
    {rank < 3 ? `#${rank + 1} · ` : ""}{s.score}%
  </span>
);

export const PhotoGrid = ({ items, testid, empty, scores }) => {
  if (!items?.length) return <div className="font-mono text-xs text-muted-foreground px-1">{empty}</div>;
  const ranked = scores ? Object.values(scores).sort((a, b) => b.score - a.score).map((s) => s.url) : [];
  return (
    <div data-testid={testid} className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 gap-2">
      {items.map((o, i) => {
        const s = scores?.[o.photo];
        const rank = s && s.score >= 40 ? ranked.indexOf(o.photo) : s ? 99 : -1;
        return (
          <a key={o.id || i} href={o.url} target="_blank" rel="noreferrer" data-testid={`${testid}-item-${i}`} title={s?.reason}
            className={`group relative rounded overflow-hidden border bg-secondary/40 hover:border-primary transition-colors ${rank > -1 && rank < 3 ? "ring-2 ring-emerald-500 border-emerald-500" : ""}`}>
            {s && <Score s={s} rank={rank} />}
            <div className="aspect-square overflow-hidden"><img src={o.photo} alt={o.species || ""} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" /></div>
            <div className="p-1.5 text-[10.5px] leading-snug font-mono">
              {o.species && <div className="italic truncate">{o.species}</div>}
              {(o.country || o.place) && <div className="truncate">{o.country || o.place}</div>}
              <div className="text-muted-foreground truncate">{[o.date, o.rights || o.attribution || (o.observer && `@${o.observer}`)].filter(Boolean).join(" · ")}</div>
            </div>
          </a>
        );
      })}
    </div>
  );
};

export const ExtLink = ({ href, children, testid }) => (
  <a data-testid={testid} href={href} target="_blank" rel="noreferrer" className="text-xs text-primary inline-flex items-center gap-1 hover:underline">{children} <ExternalLink className="h-3 w-3" /></a>
);
